import React from 'react';

import theme from '@adsk/alloy-react-theme';

const TaskConnectedIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.6666 12.1665H9.66659C9.39044 12.1665 9.16659 11.9426 9.16659 11.6665V9.6665C9.16659 9.39036 9.39044 9.1665 9.66659 9.1665H11.6666C11.9427 9.1665 12.1666 9.39036 12.1666 9.6665V11.6665C12.1666 11.9426 11.9427 12.1665 11.6666 12.1665ZM9.66659 13.6665C8.56202 13.6665 7.66659 12.7711 7.66659 11.6665V9.6665C7.66659 9.38913 7.72305 9.12494 7.82511 8.88481C7.81761 8.87789 7.81021 8.87079 7.80292 8.8635L5.13626 6.19683C5.12897 6.18955 5.12186 6.18215 5.11494 6.17464C4.87481 6.27671 4.61063 6.33317 4.33325 6.33317H2.33325C1.22868 6.33317 0.333252 5.43774 0.333252 4.33317V2.33317C0.333252 1.2286 1.22868 0.33317 2.33325 0.33317H4.33325C5.43782 0.33317 6.33325 1.2286 6.33325 2.33317V4.33317C6.33325 4.61055 6.27679 4.87473 6.17472 5.11486C6.18223 5.12179 6.18963 5.12889 6.19692 5.13617L8.86358 7.80284C8.87087 7.81013 8.87797 7.81753 8.88489 7.82503C9.12502 7.72297 9.38921 7.6665 9.66659 7.6665H11.6666C12.7712 7.6665 13.6666 8.56193 13.6666 9.6665V11.6665C13.6666 12.7711 12.7712 13.6665 11.6666 13.6665H9.66659ZM4.33325 4.83317H2.33325C2.05711 4.83317 1.83325 4.60931 1.83325 4.33317V2.33317C1.83325 2.05703 2.05711 1.83317 2.33325 1.83317H4.33325C4.60939 1.83317 4.83325 2.05703 4.83325 2.33317V4.33317C4.83325 4.60931 4.60939 4.83317 4.33325 4.83317Z"
      fill={theme.colors.charcoal500}
    />
  </svg>
);

export default TaskConnectedIcon;
